import * as React from 'react';

var _path, _path2, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgToken = function SvgToken(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_7609_2303)",
        fillOpacity: 0.16,
        d: "M17 58.767 44.061 74l27.062-15.233V28.786L44.06 14 17 28.786z"
    })), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_7609_2303",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_7609_2303)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_7609_2303)",
        d: "M40.061 70 13 54.767V24.786L40.06 10l27.061 14.786v29.981zm-8.828-36.33a12.1 12.1 0 0 1 3.933-3.26 10.5 10.5 0 0 1 4.895-1.185q2.608 0 4.895 1.184a12.1 12.1 0 0 1 3.934 3.26l14.32-8.142-23.149-12.71-23.149 12.71zm8.828 14.657q3.514 0 5.92-2.406T48.389 40q0-3.516-2.406-5.921t-5.92-2.406q-3.515 0-5.921 2.406T31.735 40t2.406 5.92 5.92 2.407m1.225 18.134L64.673 53.33V27.547l-14.638 8.32q.38 1.06.59 2.067.212 1.007.212 2.066 0 4.096-2.737 7.096t-6.814 3.747z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_7609_2303",
        x1: 17.565,
        x2: 70.369,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_7609_2303",
        x1: 13.565,
        x2: 66.369,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgToken as ReactComponent };
//# sourceMappingURL=Token.svg.es.js.map
